import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { 
    setOrder, 
    onUpdateColumn, 
    ObtenerPedidoSpot, 
    setSelectedRowSpot, 
    btnApprove, 
    btnSearchPedidoSpot,
    actualiza } from '../../../store/movilidad/bandejaprobacion/actions';
import { sort_by } from '../../../helpers/commons';
import DetalleAprobacionPedidoSpot from './DetalleAprobacionPedidoSpot';
import Modal from '@material-ui/core/Modal';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    listRoot: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
    },
    tableWrapper: {
        flex: '1 1 auto',
    },
    modalCard: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '82%',
        maxWidth: '860px',
        maxHeight: '88vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.22)',
        overflow: 'hidden',
        fontFamily: '"Segoe UI", Roboto, sans-serif',
        outline: 'none',
        '@media (max-width: 599px)': {
            width: '96%',
            maxHeight: '94vh',
        },
    },
    modalHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 16px',
        background: 'linear-gradient(90deg, #003399 0%, #0055CC 100%)',
        flexShrink: 0,
    },
    modalTitulo: {
        color: '#FFFFFF',
        fontSize: '13px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        margin: 0,
    },
    modalBtnCerrarX: {
        background: 'rgba(255,255,255,0.18)',
        border: 'none',
        color: '#FFFFFF',
        borderRadius: '5px',
        width: '26px',
        height: '26px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        flexShrink: 0,
        '&:hover': { background: 'rgba(255,255,255,0.32)' },
    },
    modalBody: {
        flex: '1 1 auto',
        overflowY: 'auto',
        padding: '12px 16px',
        backgroundColor: '#F5F7FA',
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderTop: '1px solid #DDE3EF',
        backgroundColor: '#FFFFFF',
        flexShrink: 0,
        '@media (max-width: 400px)': {
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
    },
    btnAprobar: {
        backgroundColor: '#1A7F3C',
        color: '#FFFFFF',
        fontWeight: 600,
        fontSize: '12px',
        padding: '5px 14px',
        borderRadius: '5px',
        textTransform: 'none',
        minWidth: 'unset',
        boxShadow: '0 1px 4px rgba(26,127,60,0.3)',
        '&:hover': { backgroundColor: '#166B32' },
    },
    btnRechazar: {
        backgroundColor: '#C0392B',
        color: '#FFFFFF',
        fontWeight: 600,
        fontSize: '12px',
        padding: '5px 14px',
        borderRadius: '5px',
        textTransform: 'none',
        minWidth: 'unset',
        boxShadow: '0 1px 4px rgba(192,57,43,0.3)',
        '&:hover': { backgroundColor: '#A93226' },
    },
    btnCerrar: {
        backgroundColor: '#FFFFFF',
        color: '#003399',
        fontWeight: 600,
        fontSize: '12px',
        padding: '5px 14px',
        borderRadius: '5px',
        textTransform: 'none',
        minWidth: 'unset',
        border: '1.5px solid #003399',
        '&:hover': { backgroundColor: '#EEF2FF' },
    },
}));

function DialogRechazo({ abierto, motivo, onChangeMotivo, onCancelar, onAceptar }) {
    return (
        <Dialog
            open={abierto}
            fullWidth
            maxWidth="sm"
            onClose={onCancelar}
            aria-labelledby="dialog-rechazo-titulo"
        >
            <DialogTitle id="dialog-rechazo-titulo">Motivo de Rechazo</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Ingrese el motivo del rechazo"
                    multiline
                    minRows={3}
                    fullWidth
                    value={motivo}
                    onChange={(e) => onChangeMotivo(e.target.value)}
                    inputProps={{ maxLength: 200 }}
                    helperText={`${motivo.length} / 200 caracteres`}
                    variant="outlined"
                />
            </DialogContent>
            <DialogActions style={{ padding: '8px 16px', gap: '8px' }}>
                <Button
                    color="default"
                    variant="outlined"
                    onClick={onCancelar}
                >
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={!motivo.trim()}
                    onClick={onAceptar}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function BandejAprobacionPedidoSpotList() {
    const classes    = useStyles();
    const columns    = useSelector((s) => s.bandejaaprobacion.tablePedidoSpot.columns);
    const loading    = useSelector((s) => s.bandejaaprobacion.loading);
    const order      = useSelector((s) => s.bandejaaprobacion.tablePedidoSpot.order);
    const orderBy    = useSelector((s) => s.bandejaaprobacion.tablePedidoSpot.orderBy);
    const store      = useSelector((s) => s.bandejaaprobacion.store);
    const pedidoSpot = useSelector((s) => s.bandejaaprobacion.store.detallepedidoSpot);

    const dispatch = useDispatch();

    // ── Estado: modal principal
    const [modalAbierto, setModalAbierto] = useState(false);

    const abrirModal  = () => setModalAbierto(true);
    const cerrarModal = () => {
        setModalAbierto(false);
        dispatch(btnSearchPedidoSpot());
    };

    // ── Estado: dialog de rechazo
    const [dialogRechazoAbierto, setDialogRechazoAbierto] = useState(false);
    const [motivoRechazo, setMotivoRechazo]               = useState('');

    const abrirDialogRechazo  = () => {
        setMotivoRechazo('');
        setDialogRechazoAbierto(true);
    };
    const cerrarDialogRechazo = () => setDialogRechazoAbierto(false);

    const handleAceptarRechazo = () => {
        dispatch(actualiza(pedidoSpot.pedidoId, 'R', motivoRechazo, 'PED'));
        cerrarDialogRechazo();
        // cerrarModal();
    };

    const handleDobleClick = (item) => {
        dispatch(ObtenerPedidoSpot(item));
        abrirModal();
    };

    const handleOrdenar = (propiedad) => {
        const isAsc = orderBy === propiedad && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', propiedad, 'tablePedidoSpot'));
        let filas = store.dataPedidoSpot;
        filas.sort(sort_by(propiedad, isAsc, filas[0][propiedad]));
    };

    const handleRedimensionarColumna = (columna) => {
        dispatch(onUpdateColumn(columna));
    };

    const botonesAccion = (
        <div className={classes.modalFooter}>
            {pedidoSpot.estado === 'P' && (
                <>
                    <Button
                        variant="contained"
                        className={classes.btnAprobar}
                        startIcon={<Icon className="fa fa-check" style={{ fontSize: '13px' }} />}
                        size="small"
                        onClick={() => dispatch(btnApprove())}
                    >
                        Aprobar
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.btnRechazar}
                        startIcon={<Icon className="fas fa-ban" style={{ fontSize: '13px' }} />}
                        size="small"
                        onClick={abrirDialogRechazo}
                    >
                        Rechazar
                    </Button>
                </>
            )}
            <Button
                variant="outlined"
                className={classes.btnCerrar}
                startIcon={<Icon className="fas fa-door-open" style={{ fontSize: '13px' }} />}
                size="small"
                onClick={cerrarModal}
            >
                Cerrar
            </Button>
        </div>
    );

    return (
        <FieldSet className={classes.listRoot} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrapper}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={(items) => dispatch(setSelectedRowSpot(items))}
                    onRowDoubleClick={(item) => handleDobleClick(item)}
                    onSort={(datakey) => handleOrdenar(datakey)}
                    onUpdateColumn={() => handleRedimensionarColumna}
                    rowCount={store.dataPedidoSpot.length}
                    rowGetter={(index) => store.dataPedidoSpot[index]}
                    selected={store.selectedPedidoSpot}
                    sortBy={orderBy}
                    sortDirection={order}
                    noRowsRenderer={() => <div />}
                />
            </div>
            <Modal aria-labelledby="modal-pedido-spot" open={modalAbierto} onClose={cerrarModal}>
                <div className={classes.modalCard}>
                    <div className={classes.modalHeader}>
                        <h3 className={classes.modalTitulo}>
                            <Icon className="fas fa-file-invoice" style={{ fontSize: '14px' }} />
                            Detalle de Pedido Spot
                        </h3>
                        <button className={classes.modalBtnCerrarX} onClick={cerrarModal} title="Cerrar">
                            <Icon className="fas fa-times" style={{ fontSize: '12px' }} />
                        </button>
                    </div>

                    <Box className={classes.modalBody}>
                        <DetalleAprobacionPedidoSpot />
                    </Box>

                    {botonesAccion}
                </div>
            </Modal>
            <DialogRechazo
                abierto={dialogRechazoAbierto}
                motivo={motivoRechazo}
                onChangeMotivo={setMotivoRechazo}
                onCancelar={cerrarDialogRechazo}
                onAceptar={handleAceptarRechazo}
            />
        </FieldSet>
    );
}

export default BandejAprobacionPedidoSpotList;